var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 12.9167V17.5M13.8333 11.0833V17.5M17.5 7.41667V17.5M19.3333 1L11.4078 8.9255C11.3653 8.96818 11.3147 9.00205 11.259 9.02515C11.2033 9.04826 11.1436 9.06015 11.0833 9.06015C11.023 9.06015 10.9634 9.04826 10.9077 9.02515C10.852 9.00205 10.8014 8.96818 10.7588 8.9255L7.74117 5.90783C7.65522 5.82191 7.53866 5.77364 7.41712 5.77364C7.29559 5.77364 7.17903 5.82191 7.09308 5.90783L1 12M2.83333 14.75V17.5M6.5 11.0833V17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionBookIcon);
export default __webpack_public_path__ + "static/media/PositionBookIcon.2d130f960a9aa2a649351612b0c767bb.svg";
export { ForwardRef as ReactComponent };